module.exports = __webpack_public_path__ + "media/images/area/feature/prefecture/gunma/2-13e25d4431003d94a56db5969ebacc1d.png";